import { useEffect } from 'react';

import { appLayoutAdapter } from '@/utils/appLayoutAdapter';
import { initAppToken } from '@/utils/appToken';
import isApp from '@/utils/ua';

export function AppAdapter() {
  useEffect(() => {
    if (isApp()) {
      initAppToken();
      appLayoutAdapter();
    }
  }, []);

  return <></>;
}

export default AppAdapter;
